import { FormikValues, useFormikContext } from 'formik';
import React from 'react';

interface Props {
    campo: string;
}

const Erro = ({ campo }: Props): React.ReactElement =>
{
    // Recupera os erros do formulário
    const { errors } = useFormikContext<FormikValues>();

    return (
        <small className="text-danger">
            { errors[campo] && errors[campo] }
        </small>
    );
}

export default Erro;
